/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecReviewSREntityResultDataRequest
 */
export interface SecReviewSREntityResultDataRequest {
    /**
     * 
     * @type {string}
     * @memberof SecReviewSREntityResultDataRequest
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof SecReviewSREntityResultDataRequest
     */
    url?: string;
}

/**
 * Check if a given object implements the SecReviewSREntityResultDataRequest interface.
 */
export function instanceOfSecReviewSREntityResultDataRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SecReviewSREntityResultDataRequestFromJSON(json: any): SecReviewSREntityResultDataRequest {
    return SecReviewSREntityResultDataRequestFromJSONTyped(json, false);
}

export function SecReviewSREntityResultDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewSREntityResultDataRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': !exists(json, 'path') ? undefined : json['path'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function SecReviewSREntityResultDataRequestToJSON(value?: SecReviewSREntityResultDataRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'url': value.url,
    };
}

